import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

import type {
    getTeacherAccessPermissionsData as GqlTeacherAccessPermissionsDataResponse,
    getTeacherAccessPermissionsDataVariables as GqlTeacherAccessPermissionsDataVariables,
} from "./__graphql-types__/getTeacherAccessPermissionsData.ts";

export const TEACHER_ACCESS_PERMISSIONS_DATA: GqlOperation<
    GqlTeacherAccessPermissionsDataResponse,
    GqlTeacherAccessPermissionsDataVariables
> = gqlOp(gql`
    query getTeacherAccessPermissionsData {
        user {
            id
            age
            joined
            isTeacher
            isFormalTeacher
            isK4dTeacher
            hasAccessToAIGuideTeacher
            isAIGuideEnabled
            hasChildren
            hasClasses
            isKmapStudent
            isK4dStudent
            hasAccessToAIGuideDistrictClassroomTeacher
            classrooms {
                id
                cacheId
                isK4dClassroom
            }
            coachedChildAssignmentsClassrooms {
                id
                cacheId
                students {
                    id
                    includesDistrictOwnedData
                }
            }
        }
    }
`);
